import React, { useState, useEffect } from 'react';

const StudentList = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    class: 'All',
    section: 'All'
  });

  useEffect(() => {
    // Mock data for students
    const mockStudents = [
      {
        id: 1,
        name: 'John Doe',
        roll: 'STU001',
        class: 'Grade 10',
        section: 'A',
        session: '2023-2024',
        email: 'john.doe@example.com',
        phone: '+1234567890',
        guardianName: 'Robert Doe',
        guardianPhone: '+1234567891',
        admissionDate: '2023-06-15'
      },
      {
        id: 2,
        name: 'Jane Smith',
        roll: 'STU002',
        class: 'Grade 9',
        section: 'B',
        session: '2023-2024',
        email: 'jane.smith@example.com',
        phone: '+1234567892',
        guardianName: 'Michael Smith',
        guardianPhone: '+1234567893',
        admissionDate: '2023-06-16'
      },
      {
        id: 3,
        name: 'Robert Johnson',
        roll: 'STU003',
        class: 'Grade 11',
        section: 'A',
        session: '2023-2024',
        email: 'robert.johnson@example.com',
        phone: '+1234567894',
        guardianName: 'William Johnson',
        guardianPhone: '+1234567895',
        admissionDate: '2023-06-17'
      }
    ];
    
    setStudents(mockStudents);
    setLoading(false);
  }, []);

  const filteredStudents = students.filter(student => {
    return (
      (filters.class === 'All' || student.class === filters.class) &&
      (filters.section === 'All' || student.section === filters.section)
    );
  });

  const classes = ['All', 'Nursery', 'KG', 'Grade 1', 'Grade 2', 'Grade 3', 'Grade 4', 'Grade 5', 'Grade 6', 'Grade 7', 'Grade 8', 'Grade 9', 'Grade 10', 'Grade 11', 'Grade 12'];
  const sections = ['All', 'A', 'B', 'C', 'D'];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-2xl">Loading...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen py-8">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gray-800">Manage Students</h1>
          <a 
            href="/admin/students/add" 
            className="bg-primary text-white px-6 py-2 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Add New Student
          </a>
        </div>

        {/* Filters */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-gray-700 mb-2">Class</label>
              <select
                className="w-full p-2 border rounded"
                value={filters.class}
                onChange={(e) => setFilters({...filters, class: e.target.value})}
              >
                {classes.map(cls => (
                  <option key={cls} value={cls}>{cls}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-2">Section</label>
              <select
                className="w-full p-2 border rounded"
                value={filters.section}
                onChange={(e) => setFilters({...filters, section: e.target.value})}
              >
                {sections.map(section => (
                  <option key={section} value={section}>{section}</option>
                ))}
              </select>
            </div>
            <div className="flex items-end">
              <button className="w-full bg-primary text-white px-4 py-2 rounded hover:bg-blue-700">
                Apply Filters
              </button>
            </div>
          </div>
        </div>

        {/* Students Table */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Roll</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Class</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Section</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Guardian</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Admission Date</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {filteredStudents.map((student) => (
                  <tr key={student.id}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-900">{student.name}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{student.roll}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{student.class}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{student.section}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{student.email}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{student.phone}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{student.guardianName}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{student.admissionDate}</td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm space-x-2">
                      <a href={`/admin/students/edit/${student.id}`} className="text-blue-600 hover:text-blue-900">Edit</a>
                      <a href={`/admin/students/view/${student.id}`} className="text-gray-600 hover:text-gray-900 ml-2">View</a>
                      <button className="text-red-600 hover:text-red-900 ml-2">Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentList;